import { render } from "./ConversationItem.vue?vue&type=template&id=33c57a47&scoped=true&lang=pug"
import script from "./ConversationItem.vue?vue&type=script&lang=js"
export * from "./ConversationItem.vue?vue&type=script&lang=js"

import "./ConversationItem.vue?vue&type=style&index=0&id=33c57a47&lang=scss&scoped=true"
import "./ConversationItem.vue?vue&type=style&index=1&id=33c57a47&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c57a47"]])

export default __exports__